import { render, staticRenderFns } from "./AuditsDetail.vue?vue&type=template&id=5f43d497&"
import script from "./AuditsDetail.vue?vue&type=script&lang=js&"
export * from "./AuditsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports